import React, { useEffect } from 'react'
import classNames from 'classnames'
import { CheckCircle, XCircle, X } from "@phosphor-icons/react";

export default function Alert({
    text,
    type,
    visible,
    setVisible
}) {

    const Classes = classNames({
        "fixed": true,
        "flex": true,
        "justify-center": true,
        "items-center": true,
        "top-100": true,
        "right-10": true,
        "p-6": true,
        "box-border": true,
        "mb-4": true,
        "text-sm": true,
        "rounded-lg": true,
        "border": true, 
        "bg-white": true,
        "text-black": true, 
        "border-green": type === "success", 
        "shadow-md": true,
    })

    useEffect(() => {
        if(!visible) return
        const timer = setTimeout(() => {
            setVisible()
        }, 4000);
        return () => clearTimeout(timer);
    }, [visible, setVisible]);

    if (!visible) {
        return  null
    }

    return (
        <div className={Classes}>
            <div className='flex items-center p-sm box-border'>
                {type === "success" && <CheckCircle className="h-6 w-6 mr-2 fill-green rounded-full"/>}
                {type === "error" && <XCircle className="h-6 w-6 mr-2 fill-red rounded-full"/>}

                {text}  
            </div>

            <div className='p-2 hover:bg-light rounded-md ml-2 cursor-pointer' onClick={() => setVisible()}>
                <X className="h-5 w-5 fill-grey"/>
            </div>  
        </div>
    )
}